module.exports = __webpack_public_path__ + "img/FRA.0d2cfcea.svg";